var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        {
          staticClass: "neu-cards-ctn landing-cnt",
          attrs: { cols: "1", "cols-xl": "4" }
        },
        [
          _c("PatientPanelServiceBlock", {
            attrs: {
              id: "new-consultation",
              visible: _vm.showSearchBlock,
              title: _vm.inCompanies
                ? _vm.$t("patient-panel.get-new-consultation")
                : _vm.$t("patient-panel.get-new-consultation-or-service"),
              path: "/patient/panel-search",
              img:
                "/static-appopensalud/img/icons/morillas-svg-icons/primary/medic.svg"
            }
          }),
          _vm._v(" "),
          _c("PatientPanelServiceBlock", {
            attrs: {
              id: "next-consultations",
              visible: "",
              title: _vm.$t("patient-panel.go-to-next-consultations"),
              path: "/patient/appointments/next",
              img: "/static-appopensalud/img/icons/next-appointments.svg"
            }
          }),
          _vm._v(" "),
          _c("PatientPanelServiceBlock", {
            attrs: {
              id: "past-consultations",
              visible: "",
              title: _vm.$t("patient-panel.go-to-past-consultation"),
              path: "/patient/appointments/past",
              img: "/static-appopensalud/img/icons/past-appointments.svg"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57c309d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57c309d3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/patient/AppointmentsPanelMenu.vue
// module id = 3886
// module chunks = 25